import { Link } from 'react-router-dom';

interface RankingSidebarProps {
  rankings: any[];
  title?: string;
}

export default function RankingSidebar({ rankings, title = '人气排行' }: RankingSidebarProps) {
  return (
    <div className="bg-background-50 rounded-lg border border-background-200/60 p-4">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-1 h-5 bg-accent-500 rounded-full"></div>
        <h3 className="font-heading text-base text-foreground-950">{title}</h3>
      </div>
      <div className="flex flex-col gap-1">
        {rankings.slice(0, 10).map((comic, index) => (
          <Link
            key={comic.id}
            to={`/comic/${comic.id}`}
            className="flex items-center gap-3 p-2 rounded-lg hover:bg-background-100 transition-colors cursor-pointer group"
          >
            <span className={`w-5 h-5 flex items-center justify-center rounded text-xs font-bold flex-shrink-0 ${
              index < 3 ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-foreground-500'
            }`}>
              {index + 1}
            </span>
            <div className="flex-1 min-w-0">
              <p className="text-sm text-foreground-950 truncate group-hover:text-primary-500 transition-colors">{comic.title}</p>
              <p className="text-xs text-foreground-400">{comic.category} · {comic.author}</p>
            </div>
            <span className="text-xs text-accent-500 flex-shrink-0">{comic.rating}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}